/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('MemberManagementDinghy', MemberManagementDinghy);

    MemberManagementDinghy.$inject = ['$resource', 'DateUtils'];

    function MemberManagementDinghy ($resource, DateUtils) {
        var resourceUrl =  'api/board/profiles/dinghy/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.birthdate = DateUtils.convertLocalDateFromServer(data.birthdate);
                    }
                    return data;
                }
            }
        });
    }
})();
